// /perfil/edad — Selector +18 / +21
import React, { useState } from 'react';
import { ChevronLeft, Check } from 'lucide-react';
import { COLORS } from './designSystem';
import { getStoredAge, setStoredAge } from './userStore';
import { PhoneShell, useSafeBack } from './components';

export default function AgePage() {
  const goBack = useSafeBack('/perfil');
  const [age, setAge] = useState(getStoredAge() || 18);
  const save = () => { setStoredAge(age); goBack(); };
  return (
    <PhoneShell>
      <header className="px-5 pt-6 pb-4 flex items-center gap-3">
        <button onClick={goBack} className="w-10 h-10 flex items-center justify-center rounded-full" style={{ backgroundColor: COLORS.surface }} data-testid="age-back"><ChevronLeft size={22} color={COLORS.text} /></button>
        <h1 className="text-white text-xl font-extrabold">Mi edad</h1>
      </header>
      <section className="px-5">
        <p className="text-sm mb-4" style={{ color: COLORS.textMuted }}>Guardamos tu edad para que solo veas eventos a los que puedes entrar.</p>
        <div className="space-y-3 mb-6">
          {[18, 21].map((a) => (
            <button key={a} onClick={() => setAge(a)} className="w-full flex items-center justify-between p-4 rounded-2xl text-left" style={{ backgroundColor: COLORS.surface, border: `1px solid ${age === a ? COLORS.primary : COLORS.border}` }} data-testid={`age-option-${a}`}>
              <div>
                <p className="text-white font-bold text-lg">+{a}</p>
                <p className="text-xs" style={{ color: COLORS.textMuted }}>{a === 18 ? 'Tienes 18 años o más' : 'Tienes 21 años o más'}</p>
              </div>
              {age === a && <Check size={20} color={COLORS.primary} />}
            </button>
          ))}
        </div>
        <button onClick={save} className="w-full py-3.5 rounded-full text-white font-bold" style={{ backgroundColor: COLORS.primary }} data-testid="age-save">Guardar</button>
      </section>
    </PhoneShell>
  );
}
